import { Button, ButtonProps } from '@mui/material';
import React from 'react';

export const PrimaryButton = (props: ButtonProps) => {
  return <Button color={'primary'} {...props} />;
};
